import React from "react";
import PropTypes from "prop-types";
import KeyboardArrowDownOutlined from "@mui/icons-material/KeyboardArrowDownOutlined";
import { cn } from "../cn";
import styles from "./Select.module.scss";

/**
 * Select — a token-styled native <select>. `onChange` receives the selected
 * value (not the event) to match the antd Select ergonomics it replaces.
 * options: [{ value, label }]. Pass `placeholder` for an empty leading option.
 */
const Select = React.forwardRef(function Select(
  {
    value,
    onChange,
    options = [],
    placeholder,
    disabled = false,
    size = "md",
    className,
    ...rest
  },
  ref
) {
  return (
    <span className={cn(styles.wrap, styles[size], disabled && styles.disabled, className)}>
      <select
        ref={ref}
        className={styles.select}
        value={value == null ? "" : value}
        onChange={(e) => onChange && onChange(e.target.value)}
        disabled={disabled}
        {...rest}
      >
        {placeholder != null && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <KeyboardArrowDownOutlined className={styles.chevron} fontSize="small" />
    </span>
  );
});

Select.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.node,
    })
  ),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(["sm", "md"]),
  className: PropTypes.string,
};

export default Select;
